export function isMailValid(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function isUrlValid(url) {
  try {
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
}
